import React from 'react';
import { motion } from 'framer-motion';
import { PlaceholderMockup } from './ui/PlaceholderMockup';
import type { BonoContent } from '../types/content';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
interface BonoItemProps {
  bono: BonoContent;
  index: number;
}
export function BonoItem({
  bono,
  index
}: BonoItemProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.4,
    ease: easeOut,
    delay: index % 4 * 0.05
  }} className={`flex flex-col overflow-hidden rounded-2xl border bg-mp-card ${bono.premiumOnly ? 'border-mp-lime/40' : 'border-mp-border'}`} data-id="element-31" data-mp="2d5p4mu233ck3">
      <div className="p-4 pb-0" data-id="element-32" data-mp="1uba593bv1hvq">
        <PlaceholderMockup label={bono.imageLabel} aspect="aspect-[4/3]" src={bono.imageUrl} alt={bono.imageLabel} width={500} height={375} data-id="element-33" data-mp="3jodp1khp5qyj" />
      </div>
      <div className="flex flex-1 flex-col p-5" data-id="element-34" data-mp="3omffwrld6ukk">
        <div className="flex items-center justify-between gap-2" data-id="element-35" data-mp="7vym48ojtm4c">
          <span className="rounded-full border border-mp-lime/40 bg-mp-lime/5 px-2.5 py-1 font-heading text-[10px] uppercase tracking-wide text-mp-lime" data-id="element-36" data-mp="7u5f2sa0wzvt">
            {bono.tag}
          </span>
          {bono.premiumOnly && <span className="font-heading text-[10px] uppercase tracking-wide text-mp-electric" data-id="element-37" data-mp="cmos9o4stt03">Solo Kit</span>}
        </div>
        <h3 className="mt-3 font-heading text-base uppercase leading-snug text-mp-white" data-id="element-38" data-mp="3l3tdc50egg9b">{bono.title}</h3>
        <p className="mt-1.5 text-sm leading-relaxed text-mp-gray" data-id="element-39" data-mp="3g5i3vve0o7rm">{bono.oneLiner}</p>
        {bono.note && <p className="mt-3 text-xs leading-relaxed text-mp-gray/70" data-id="element-40" data-mp="3u59ls77nm8aw">{bono.note}</p>}
      </div>
    </motion.div>;
}